import httpClient from './httpClient'

export default {
  async getCreditsHistory(startDate, endDate) {
    let ret = await httpClient.get(`/credits?type=general&start_date=${startDate}&end_date=${endDate}&type=general`)
    return ret
  },
  async getCreditDetails(creditId) {
    let ret = await httpClient.get(`/credits/${creditId}`)
    return ret
  },
  async getCreditsBalance() {
    let ret = await httpClient.get('/credits', {
      params: { hide_history: true },
    })
    return ret
  },
  async addCredit(creditData) {
    let ret = await httpClient.post('/credits', creditData)
    return ret
  },
}
